<div class="modal-header border-0" [class.bg-neutral-50]="modalMode">
  <h4 class="modal-title" *ngIf="(title!=='Keyword') && (title!=='Lot Number')">Select {{title}}</h4>
  <h4 class="modal-title" *ngIf="(title==='Keyword') || (title==='Lot Number')">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="Close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body border-0" [class.bg-neutral-25]="modalMode" [class.componentMode]="!modalMode" style="max-height: 80vh;">
  <form #thisForm="ngForm">
    <ng-content></ng-content>
  </form>
</div>
<div class="modal-footer border-0 pt-0" [class.bg-neutral-50]="modalMode">
  <div class="row w-100">
    <div class="col-6 p-0">
      <button type="button" class="btn btn-primary btn-red p-2 mt-2" (click)="Save(thisForm,$event)" *ngIf="!processing">Apply</button>
      <span class="btn btn-dark" *ngIf="processing"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
    </div>
  </div>
</div>
